

import './index.less'
import Swiper from 'swiper'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'


import EsQuery from '@/javascript/esQuery'
import util from "@/javascript/util";
import Footer from "@/components/lyx-components/lyx-footer/index"
import goBack from '@/components/public-components/goBack/index.vue'
export default {
components: {
Tab,
TabItem,
Footer,
goBack
},
data () {
return {
isWeixin: util.isWeiXin(),
minHeight: 0,
cityData: [],
curFood: 0,
currentFood: 0,
foodList: [],
curFilterItem: false,
curArea: 0,
simName: '',
locationName: '',//小吃
foodData: [],
foodName: '', //餐饮
foodTitle: '',
scenicsListPageNo: 0,
scenicsListPageSize: 100,
begfoodData: [],
areaCode: '',
showSearch: false,
searchValue: '',
canBtn: true,
allProduct: [],
foodPageSize: 500,
xcShow: [],
cyShow: [],
allLong: '',
cityName: []
}
},
mounted () {
const _this = this
_this.minHeight = document.documentElement.clientHeight - this.$refs.footer.$el.offsetHeight;
document.title = "美食"

/**
* 微信签名分享
*/


















const querystring = require('querystring');
const allXcEsQuery = new EsQuery()
allXcEsQuery
.addString("category", _this.XXCJ_TYPE_CODE.MS, allXcEsQuery.and, false)


.addPage(_this.scenicsListPageNo, _this.foodPageSize)
const allXcEsJsonQuery = JSON.stringify(allXcEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: _this.INDEX_NAME_TYPE.periphery,
esJsonQuery: allXcEsJsonQuery
})).then(function (res) {
const xcList = res.data.data;
xcList.map(item => {

item._source.toUrl = '/specialDetails/X/' + item._source.id
_this.xcShow.push(item)

})
_this.allLong = _this.xcShow.length
_this.$set(_this, 'allProduct', _this.xcShow)
})


const allCyEsQuery = new EsQuery()
allCyEsQuery
.addString("category", _this.XXCJ_TYPE_CODE.MS, allCyEsQuery.and, false)


.addPage(_this.scenicsListPageNo, _this.foodPageSize)
.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, allCyEsQuery.and, false)
const allCyEsJsonQuery = JSON.stringify(allCyEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: _this.INDEX_NAME_TYPE.periphery,
esJsonQuery: allCyEsJsonQuery
})).then(function (res) {

const cyList = res.data.data;
cyList.map(item => {

item._source.toUrl = '/businessView/' + _this.XXCJ_TYPE_CODE.CY + '/' + item._source.id
_this.cyShow.push(item)

})

_this.$set(_this, 'allProduct', _this.allProduct.concat(_this.cyShow))
})
_this.init()




































},
methods: {
init () {
const _this = this
const querystring = require('querystring');
const recommendEsQuery = new EsQuery()
recommendEsQuery
.addString("category", _this.XXCJ_TYPE_CODE.MS, recommendEsQuery.and, false)
.addPage(this.scenicsListPageNo, _this.scenicsListPageSize)
.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, recommendEsQuery.and, false)



const recommendEsJsonQuery = JSON.stringify(recommendEsQuery.getArray())
this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: this.INDEX_NAME_TYPE.periphery,
esJsonQuery: recommendEsJsonQuery
})).then(function (res) {
_this.$set(_this, 'begfoodData', res.data.data)
_this.$set(_this, 'foodData', res.data.data)
_this.foodData.map(item => {
if (item._source.title.indexOf("（") != -1 || item._source.title.indexOf("(") != -1) {
var rt = /(.+)?(?:\(|（)(.+)(?=\)|）)/.exec(item._source.title);
item._source.title = (rt[1] + '·' + rt[2])
} else {
item._source.title = item._source.title
}
})
if (_this.foodData.length > 0) {
_this.$set(_this, 'foodName', _this.foodData[0]._source.id)
}

}).then(() => {
if (_this.foodData.length > 0) {
const that = this
if (_this.foodData.length == 1) {
_this.$nextTick(function () {
new Swiper('.food-swiper', {
slidesPerView: 'auto',
spaceBetween: 13,
loopedSlides: 0,
})
})
} else {
_this.$nextTick(function () {
new Swiper('.food-swiper', {
slidesPerView: 'auto',
spaceBetween: 13,
loop: false,
observer: true,
loopedSlides: 0,
onSlideChangeEnd: function (swiper) {
that.curFood = swiper.activeIndex % that.foodData.length
}
})
})
}
}
_this.foodTitle = _this.foodData[0]._source.title
_this.getStoreList()
})
},
getStoreList () {
const _this = this
if (_this.foodName != '') {
const querystring = require('querystring');
const recommendEsQuery = new EsQuery()
recommendEsQuery
.addString("category", this.XXCJ_TYPE_CODE.CY, recommendEsQuery.and, false)
.addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, recommendEsQuery.and, false)

.addString("tags", _this.foodTitle, recommendEsQuery.and, false)
.addPage(_this.scenicsListPageNo, _this.scenicsListPageSize)
const recommendEsJsonQuery = JSON.stringify(recommendEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: _this.INDEX_NAME_TYPE.periphery,
esJsonQuery: recommendEsJsonQuery
})).then(function (res) {

_this.setFoodData(res.data.data.sort(_this.getRankList('score')));
})
}
},

setFoodData (res) {
const data = res
data.map(item => {
const originName = item._source.regionFullName.split(',')
originName.splice(0, 1)
item._source.address = originName.join('') + item._source.address
})
this.$set(this, "foodList", data);

},

closeFilter () {
this.curFilterItem = false
},
showLayer () {
this.$router.push({path: '/search?type=5'})
return
const _this = this
_this.showSearch = true
},
onItemClick (item, index) {
console.log(item)
this.currentFood = index
this.foodName = item._source.id
this.foodTitle = item._source.title
this.foodList = []
this.getStoreList()
},
getRankList (prop) { //降序
return function (obj1, obj2) {
let val1 = obj1._source[prop];
let val2 = obj2._source[prop];
if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
val1 = Number(val1);
val2 = Number(val2);
}
if (val1 < val2) {
return 1;
} else if (val1 > val2) {
return -1;
} else {
return 0;
}
}
},
cancelBtn () {
const _this = this
_this.showSearch = false
_this.canBtn = true
_this.searchValue = ''
},
textInner () {
const _this = this
_this.showSearch = true
_this.canBtn = true
},

}
}
